import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { IAssetTransferRequestDto } from '~/models/modules/Asset/Transactions/Transfer/assetTransferDto';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class AssetTransferTransactionsService extends ApiServiceBase {
  FromInventory: any = [];
  constructor(injector: Injector, private http: HttpClient) {
      super(injector);
      this.setBase(API_NAMES.assets);
  }
  getTransferTransactionHistoryGrid(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
        .post<any[]>(this._url(`/grid-data`), model, {
            params,
            observe: 'response',
        })
        .pipe(map(augmentPaging));
  }
  createTransferTransaction(model:IAssetTransferRequestDto){
    return this.client.post<any>(this._url(), model);
  }
  updateTransferTransaction(id:number, model:IAssetTransferRequestDto){
    return this.client.post<any>(this._url(`/${id}`), model);
  }
  getTransferById(id:number){
    return this.client.get<IAssetTransferRequestDto>(this._url(`/${id}`))
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/TransferTransaction${v}`);
  }
}
